module.exports = __webpack_public_path__ + "img/Unidad12-2.c0f50c80.png";